import React from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import Header from '../../../../../components/header/Header';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { transUTL } from '../../../../../utils/transUTL';

// COMPONENTS
const ItalyTelcoMobile = ({ results, type }) => {
  if (isEmptyVAL(results[type])) return null;

  const data = results[type] ? results[type] : {};
  let {
    identityVerified,
    nameMatchScore,
    addressMatchScore,
    safeHarbourScore,
    verifications,
  } = data;

  if (isEmptyVAL(verifications)) verifications = {};

  return (
    <div className="search-verification__results">
      <Header
        title={transUTL(
          'translateSearchVerification.dataSourcesIT.italyTelcoMobile.title'
        )}
      />

      <div className="search-verification__verify">
        <div className="search-verification__col">
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.searchSuccessful'
              )}
            </p>
            <span className="material-icons success">check_circle</span>
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.safeHarbourScore'
              )}
            </p>
            {!isEmptyVAL(safeHarbourScore) ? (
              safeHarbourScore.toLowerCase() === 'add' ? (
                <span className="material-icons success">add_circle</span>
              ) : (
                  <span>{safeHarbourScore}</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.verified'
              )}
            </p>
            {!isEmptyVAL(identityVerified) ? (
              identityVerified ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
        </div>

        <div className="search-verification__col">
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.firstName'
              )}
            </p>
            {!isEmptyVAL(verifications.firstName) ? (
              verifications.firstName ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.lastName'
              )}
            </p>
            {!isEmptyVAL(verifications.lastName) ? (
              verifications.lastName ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.gender'
              )}
            </p>
            {!isEmptyVAL(verifications.gender) ? (
              verifications.gender ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.dateOfBirth'
              )}
            </p>
            {!isEmptyVAL(verifications.dateOfBirth) ? (
              verifications.dateOfBirth ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.phoneNo'
              )}
            </p>
            {!isEmptyVAL(verifications.phoneNo) ? (
              verifications.phoneNo ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
        </div>

        <div className="search-verification__col">
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.street'
              )}
            </p>
            {!isEmptyVAL(verifications.street) ? (
              verifications.street ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.city'
              )}
            </p>
            {!isEmptyVAL(verifications.city) ? (
              verifications.city ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.state'
              )}
            </p>
            {!isEmptyVAL(verifications.state) ? (
              verifications.state ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.postCode'
              )}
            </p>
            {!isEmptyVAL(verifications.postCode) ? (
              verifications.postCode ? (
                <span className="material-icons success">check_circle</span>
              ) : (
                  <span className="material-icons error">cancel</span>
                )
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>

          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.nameMatchScore'
              )}
            </p>
            {!isEmptyVAL(nameMatchScore) ? (
              <span>{nameMatchScore}</span>
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
          <div className="search-verification__verify-item">
            <p>
              {transUTL(
                'translateSearchVerification.dataSourcesIT.italyTelcoMobile.addressMatchScore'
              )}
            </p>
            {!isEmptyVAL(addressMatchScore) ? (
              <span>{addressMatchScore}</span>
            ) : (
                <span>{transUTL('translateReuse.na')}</span>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

ItalyTelcoMobile.propTypes = {
  results: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default ItalyTelcoMobile;
